import React from 'react';
import PropTypes from 'prop-types';
import VmGasModal from '../vm-gas-modal';

import './style';
import Video from './Video';
const TABS_BASE = 'gas-video-base';
const VtxGasVideoModal = ({ billId = '', ...resetProps }) => {
    const tabs = [
        {
            value: '视频信息',
            key: TABS_BASE,
            content: <Video billId={billId} />,
        },
    ];
    return <VmGasModal title={billId} {...resetProps} tabs={tabs} subtitle="查看" />;
};

VtxGasVideoModal.propTypes = {
    billId: PropTypes.string,
};

export default VtxGasVideoModal;
